class UserGroup {
  constructor(
    id="",
    groupTitle = "",
    groupDescription = "",
  ) {
    this.id = id;
    this.groupTitle = groupTitle;
    this.groupDescription = groupDescription;
    this.workflows = [];
    this.caseExpressions = [];
    this.portalUsers = [];
  }

  setWorkflows(workflows) {
    this.workflows = workflows;
  }

  setCaseExpressions(expressions) {
    this.caseExpressions = expressions
  }

  setPortalUsers(portalUsers) {
    this.portalUsers = portalUsers
  }
}

export default UserGroup;
